import MeVsMeetingCard from "components/Insights/MeVsMeetingCard/MeVsMeetingCard";
import React from "react";
import css from "../MeetingTime/AsAttendee/AsAttendee.module.scss";
import { Flex, Loader, Switch, Text } from "@mantine/core";
import useInsights from "hooks/insights/useInsights";
import useAnalyticsStore from "stores/useAnalyticsStore";
import {
  attendeesBuckets,
  filterValidMeetings,
  formatDuration,
  minutesBuckets,
  weekdays,
} from "utils/insights";
import { useToggle } from "@mantine/hooks";
import CostCard from "components/Insights/CostCard/CostCard";
import EffectivenessCard from "components/Insights/EffectivenessCard/EffectivenessCard";
import MeetingsDistBarCardNew from "components/Insights/MeetingsDistBarCardNew/MeetingsDistBarCardNew";
import CustomFeedbackCard from "components/Insights/CustomFeedbackCard/CustomFeedbackCard";
import { useUser } from "stores/useUser";
import { useQuery } from "react-query";
import { getMeetingsForMyOrg } from "api";
import FeedbackCardV3 from "components/Insights/FeedbackCard/FeedbackCardV3";
// import {
//   mockSplitCardDataEmpty,
//   mockSplitCardDataLarge,
//   mockSplitCardDataSingle,
//   mockSplitCardDataSmall,
//   mockTagSplitCardData,
// } from "utils/mock";
import TagSplitCard from "components/Insights/TagSplitCard/TagSplitCard";
import GoalSplitCard from "components/Insights/GoalSplitCard/GoalSplitCard";
import ExternalOrgTimeCard from "components/Insights/ExternalOrgTimeCard/ExternalOrgTimeCard";
import MeetingsTableCard from "components/Insights/MeetingsTableCard/MeetingsTableCard";
import AIAnalysisOnDist from "components/Insights/AIAnalysisOnDist/AIAnalysisOnDist";
import DepartmentConnectionCard from "components/DepartmentConnectionCard/DepartmentConnectionCard";

const MyOrg = () => {
  const [self, setSelf] = useToggle(["IncludingSelf", "ExcludingSelf"]);
  const { myOrgData, isMyOrgLoading, isMyOrgError } = useInsights();
  const { duration } = useAnalyticsStore();
  const { user } = useUser();

  // this redis key store the complete meeting details array of org meetings
  const meetingDetailsRedisKey = `users:${
    user?.uid
  }:orgCalculations:${formatDuration(duration)}:${self}:totalMeetingsCostIds`;

  // custom feedback card data
  const {
    data: meetingDetailsData,
    isLoading: isMeetingDetailsLoading,
    isError: isMeetingDetailsError,
  } = useQuery({
    queryKey: ["meetingDetails", meetingDetailsRedisKey, user?.email],
    queryFn: () => getMeetingsForMyOrg(meetingDetailsRedisKey),
    enabled: !!meetingDetailsRedisKey,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });

  if (isMyOrgError) {
    return <span>Error while loading insights</span>;
  }
  if (isMyOrgLoading) {
    <div className="loader">
      <Loader />
      <Text>Loading insights ...</Text>
    </div>;
  }
  return (
    <div className={css.container} style={{ marginBottom: "1rem" }}>
      <Flex align={"center"} gap={20} justify={"flex-end"}>
        <Text fz={15} w={500} ta={"end"}>
          {self}
        </Text>
        <Switch onChange={setSelf} checked={self === "IncludingSelf"} />
      </Flex>
      <div className={css.row}>
        <MeVsMeetingCard
          type="myOrg"
          isLoading={isMyOrgLoading}
          isError={isMyOrgError}
          data={myOrgData?.["timeSplit"]?.[formatDuration(duration)]?.[self]}
          source="myOrg"
          duration={formatDuration(duration)}
          self={self}
          uid={user.uid}
        />

        <EffectivenessCard
          type="org"
          isLoading={isMyOrgLoading}
          isError={isMyOrgError}
          data={
            myOrgData?.["effectiveness"]?.[formatDuration(duration)]?.[self]
          }
          email={user?.email}
          uid={user?.uid}
          duration={formatDuration(duration)}
          self={self}
        />
        <CostCard
          type="myOrg"
          isLoading={isMyOrgLoading}
          isError={isMyOrgError}
          data={myOrgData?.["meetingCost"]?.[formatDuration(duration)]?.[self]}
          email={user?.email}
          source="myOrg"
          duration={formatDuration(duration)}
          self={self}
          uid={user.uid}
        />
      </div>

      {/* third row */}
      {/* <div className={css.row}>
        <FeedbackCardV3
          data={
            myOrgData?.["structuredFeedbacks"]?.[formatDuration(duration)]?.[
              self
            ] || {}
          }
          isLoading={isMyOrgLoading}
          isError={isMyOrgError}
          type="myOrg"
          uid={user?.uid}
          duration={formatDuration(duration)}
          self={self}
        />
        <CustomFeedbackCard
          data={
            meetingDetailsData?.filter(
              (meeting) =>
                meeting.customFeedbacks && meeting.customFeedbacks.length > 0
            ) || []
          }
          isLoading={isMeetingDetailsLoading}
          isError={isMeetingDetailsError}
        />
        <TagSplitCard
          data={myOrgData?.["tags"]?.[formatDuration(duration)]?.[self] || []}
          isLoading={isMyOrgLoading}
          isError={isMyOrgError}
          type="myOrg"
          userEmail={user?.email}
          uid={user?.uid}
          duration={formatDuration(duration)}
          self={self}
        />
      </div> */}

      {/* fourth row - External Organizations */}
      <div className={css.row}></div>

      <div className={css.row}>
        {/* <LineCard
          isLoading={isMyOrgLoading}
          isError={isMyOrgError}
          xAxisData={effectivenessLineCardData?.xAxisData}
          series={effectivenessLineCardData?.series}
          rotate={-45}
          yAxisMax={5}
          title="Effectiveness over time"
        /> */}
        <div style={{ height: "29rem" }}>
          <ExternalOrgTimeCard
            data={
              myOrgData?.["externalOrgsTime"]?.[formatDuration(duration)]?.[
                self
              ] || []
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            source="myOrg"
            duration={formatDuration(duration)}
            self={self}
            uid={user?.uid}
          />
        </div>
        <div style={{ height: "29rem" }}>
          <GoalSplitCard
            goals={
              myOrgData?.["strategicGoals"]?.[formatDuration(duration)]?.[
                self
              ] || {}
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            source="myOrg"
            duration={formatDuration(duration)}
            self={self}
            uid={user?.uid}
          />
        </div>
      </div>

      <div className={css.row} style={{ marginTop: "2rem" }}>
        <div>
          <DepartmentConnectionCard
            data={
              myOrgData?.["departmentCollaboration"]?.[
                formatDuration(duration)
              ] || []
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            source="myOrg"
            duration={formatDuration(duration)}
            uid={user?.uid}
          />
        </div>
      </div>

      {/* fifth row */}
      <div className={css.row} style={{ marginTop: "2rem" }}>
        <div style={{ height: "20rem" }}>
          <MeetingsDistBarCardNew
            data={
              myOrgData?.["meetingsDistribution"]?.[formatDuration(duration)]?.[
                self
              ]?.byDuration
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            title="Meetings Distribution"
            type="totalMeetings"
            xAxis={minutesBuckets}
            xAxisLabel={"Minutes"}
            yAxisLabel={"Meetings"}
            minYAxis={0}
            uid={user.uid}
            duration={formatDuration(duration)}
            self={self}
            source="myOrg"
            email={user.email}
            distType="byDuration"
          />
        </div>

        <div style={{ height: "20rem" }}>
          <MeetingsDistBarCardNew
            data={
              myOrgData?.["meetingsDistribution"]?.[formatDuration(duration)]?.[
                self
              ]?.byDuration
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            title="Meetings Effectiveness"
            type="averageRating"
            xAxis={minutesBuckets}
            xAxisLabel={"Minutes"}
            yAxisLabel={"Effectiveness"}
            minYAxis={0}
            maxYAxis={5}
            totalStack={false}
            uid={user.uid}
            duration={formatDuration(duration)}
            self={self}
            source="myOrg"
            email={user.email}
            distType="byDuration"
          />
        </div>
      </div>

      {/* AI analysis on meetings - by duration */}
      {myOrgData?.aiAnalysisOfMeetingsDistribution?.[
        formatDuration(duration)
      ]?.[self]?.byDuration && (
        <AIAnalysisOnDist
          insight={
            myOrgData?.aiAnalysisOfMeetingsDistribution?.[
              formatDuration(duration)
            ]?.[self]?.byDuration
          }
          by="duration"
        />
      )}

      <div className={css.row} style={{ marginTop: "2rem" }}>
        <div style={{ height: "20rem" }}>
          <MeetingsDistBarCardNew
            data={
              myOrgData?.["meetingsDistribution"]?.[formatDuration(duration)]?.[
                self
              ]?.byAttendeesSize
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            title="Dist of mtgs by size"
            type="totalMeetings"
            xAxis={attendeesBuckets}
            xAxisLabel={"No. of attendees"}
            yAxisLabel={"Meetings"}
            minYAxis={0}
            uid={user.uid}
            duration={formatDuration(duration)}
            self={self}
            source="myOrg"
            email={user.email}
            distType="byAttendeesSize"
          />
        </div>
        <div style={{ height: "20rem" }}>
          <MeetingsDistBarCardNew
            data={
              myOrgData?.["meetingsDistribution"]?.[formatDuration(duration)]?.[
                self
              ]?.byAttendeesSize
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            title="Effectiveness of mtgs by size"
            type="averageRating"
            xAxis={attendeesBuckets}
            xAxisLabel={"No. of attendees"}
            yAxisLabel={"Effectiveness"}
            minYAxis={0}
            totalStack={false}
            uid={user.uid}
            duration={formatDuration(duration)}
            self={self}
            source="myOrg"
            email={user.email}
            distType="byAttendeesSize"
          />
        </div>
      </div>
      {/* AI analysis on meetings - by attendees size */}
      {myOrgData?.aiAnalysisOfMeetingsDistribution?.[
        formatDuration(duration)
      ]?.[self]?.byAttendeesSize && (
        <AIAnalysisOnDist
          insight={
            myOrgData?.aiAnalysisOfMeetingsDistribution?.[
              formatDuration(duration)
            ]?.[self]?.byAttendeesSize
          }
          by="attendees size"
        />
      )}

      <div className={css.row} style={{ marginTop: "2rem" }}>
        <div style={{ height: "20rem" }}>
          <MeetingsDistBarCardNew
            data={
              myOrgData?.["meetingsDistribution"]?.[formatDuration(duration)]?.[
                self
              ]?.byWeekdays
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            title="Dist of mtgs over time"
            type="totalMeetings"
            xAxis={weekdays}
            xAxisLabel={"Days"}
            yAxisLabel={"Meetings"}
            minYAxis={0}
            uid={user.uid}
            duration={formatDuration(duration)}
            self={self}
            source="myOrg"
            email={user.email}
            distType="byWeekdays"
          />
        </div>
        <div style={{ height: "20rem" }}>
          <MeetingsDistBarCardNew
            data={
              myOrgData?.["meetingsDistribution"]?.[formatDuration(duration)]?.[
                self
              ]?.byWeekdays
            }
            isLoading={isMyOrgLoading}
            isError={isMyOrgError}
            title="Effectiveness of mtgs by day"
            type="averageRating"
            xAxis={weekdays}
            xAxisLabel={"Days"}
            yAxisLabel={"Effectiveness"}
            minYAxis={0}
            maxYAxis={5}
            totalStack={false}
            uid={user.uid}
            duration={formatDuration(duration)}
            self={self}
            source="myOrg"
            email={user.email}
            distType="byWeekdays"
          />
        </div>
      </div>

      {/* AI analysis on meetings - by weekdays */}
      {myOrgData?.aiAnalysisOfMeetingsDistribution?.[
        formatDuration(duration)
      ]?.[self]?.byWeekdays && (
        <AIAnalysisOnDist
          insight={
            myOrgData?.aiAnalysisOfMeetingsDistribution?.[
              formatDuration(duration)
            ]?.[self]?.byWeekdays
          }
          by="weekdays"
        />
      )}
      <MeetingsTableCard
        data={filterValidMeetings(meetingDetailsData || [])}
        isLoading={isMeetingDetailsLoading}
        isError={isMeetingDetailsError}
      />
    </div>
  );
};

export default MyOrg;
